/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-12-28 11:54:07
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-12-28 15:52:53
 * @FilePath: /wemeet-web-activity/src/utils/browser/requestAnimationFrame.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const resetQuestAnimationFrame = () => {
  let lastTime = 0;
  const vendors: Array<string> = ['webkit', 'moz'];
  for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    // @ts-ignore
    window.requestAnimationFrame = window[`${vendors[x]}RequestAnimationFrame`];
    // @ts-ignore
    window.cancelAnimationFrame =
      window[`${vendors[x]}CancelAnimationFrame`] ||
      window[`${vendors[x]}CancelRequestAnimationFrame`];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback) {
      const currTime = new Date().getTime();
      const timeToCall = Math.max(0, 16.7 - (currTime - lastTime));
      const id = window.setTimeout(() => {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
};

export default resetQuestAnimationFrame;
